import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Santiago Pérez',
  location: 'Buenos Aires',
  text: 'Cambió mi forma de jugar completamente'
}, {
  name: 'Matías López',
  location: 'Tucumán',
  text: 'Los tiros libres ahora son mi arma secreta'
}, {
  name: 'Franco Martínez',
  location: 'Santa Fe',
  text: 'Mejoré mi visión de juego en semanas'
}, {
  name: 'Agustín Silva',
  location: 'Salta',
  text: 'El mejor sistema de entrenamiento que probé'
}, {
  name: 'Joaquín Romero',
  location: 'Neuquén',
  text: 'Ahora soy el referente del equipo'
}];
export function Testimonials() {
  return <section className="bg-gray-50 py-16 md:py-24" data-id="element-159">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-160">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-161">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-lg p-6 shadow-md" data-id="element-162">
              <div className="flex gap-1 mb-3" data-id="element-163">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow-500 text-yellow-500" data-id="element-164" />)}
              </div>

              <p className="text-gray-700 mb-4 italic" data-id="element-165">"{testimonial.text}"</p>

              <div data-id="element-166">
                <p className="font-semibold text-gray-900" data-id="element-167">
                  {testimonial.name}
                </p>
                <p className="text-sm text-gray-600" data-id="element-168">{testimonial.location}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}